<ng-template #templateRef>
  <form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()" id="articleEditor">
    <div class="row align-items-center">
      <h2 mat-dialog-title class="m-0">
            {{Copy && Copy.Id ? 'Edit' : 'New'}} Article {{Copy.Code}}
            <mat-icon *ngIf="Copy.ExternalId" class="pull-right" matTooltip="Linked with ExactOnline">insert_link</mat-icon>
            <app-creator-modifier-icon style="float: right; margin-right: 10px" [object]="Copy"></app-creator-modifier-icon>
        </h2>
      <div class="fill-remaining-space"></div>
      <mat-icon *ngIf="Copy?.Parent?.IsBlocked" matTooltipPosition="above" matTooltip="Parent is blocked!" class="pull-right">warning</mat-icon>
    </div>
    <mat-dialog-content *ngIf="Copy">
      <mat-tab-group>
        <mat-tab label="General">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <input [(ngModel)]="Copy.Code" matInput name="Code" placeholder="Article code">
                <mat-icon matSuffix matTooltip="This field will be synchronised with Exact">cloud_upload</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <app-article-selector name="Parent" [(ngModel)]="Copy.Parent"
                                    placeholder="Parent Article"></app-article-selector>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <input [(ngModel)]="Copy.Barcode" matInput name="Barcode" placeholder="Barcode">
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <input [(ngModel)]="Copy.Image" disabled matInput name="Image" placeholder="Image">
                <button (click)="openAttachmentController()" mat-icon-button matSuffix type="button">
                  <mat-icon>folder</mat-icon>
                </button>
                <button (click)="Copy.Image = null" mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <input matInput name="Description" [(ngModel)]="Copy.Description"
                       placeholder="Description">
                <mat-icon matSuffix matTooltip="This field will be synchronised with Exact">cloud_upload</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <app-dropdown-option [(ngModel)]="Copy.Category1" discriminator="Category1" model="Article"
                                   name="Category1" placeholder="Category1"></app-dropdown-option>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <input [(ngModel)]="Copy.CommercialName" matInput name="CommercialName" placeholder="CommercialName">
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <input [(ngModel)]="Copy.DisplayName" matInput name="DisplayName" placeholder="DisplayName">
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <mat-form-field>
                                        <textarea matInput name="Remarks" [(ngModel)]="Copy.Remarks" rows="5"
                                                  placeholder="Remarks"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <mat-chip-grid #chipList>
                  <mat-chip-row *ngFor="let word of Copy.Keywords" [editable]="true" [removable]="true" (removed)="Copy.Keywords.splice(Copy.Keywords.indexOf(word), 1)">
                    {{word}}
                    <button matChipRemove><mat-icon>cancel</mat-icon></button>
                  </mat-chip-row>
                  <input placeholder="New keyword" #keywordInput
                         [matChipInputFor]="chipList"
                         [matChipInputAddOnBlur]="true"
                         (matChipInputTokenEnd)="Copy.Keywords.push($event.value); keywordInput.value = '';">
                </mat-chip-grid>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-checkbox [(ngModel)]="Copy.IsBlocked" name="IsBlocked">
                Blocked/Inactive
              </mat-checkbox>
              <p style="font-size: 0.8em;">Blocked articles are <strong>not visible</strong> in the reseller neither
                aorta.</p>
            </div>
            <div class="col-md-6">
              <mat-checkbox [(ngModel)]="Copy.IsUndeliverable" name="IsUndeliverable">
                Undeliverable
              </mat-checkbox>
              <p style="font-size: 0.8em;">Undeliverable articles are <strong>visible</strong> in aorta & reseller, but
                they're <strong>not possible to order</strong></p>
            </div>
          </div>

        </mat-tab>
        <mat-tab label="Reseller">
          <div class="row">
            <div class="col-md-2">
              <mat-form-field>
                <input [(ngModel)]="Copy.OptionWeight" matInput name="OptionWeight" placeholder="Option Weight">
                <mat-hint>weight value on the reseller when this article is an option</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <app-dropdown-option model="Article" placeholder="Unit" discriminator="Unit" [(ngModel)]="Copy.Unit"
                                   name="Unit"></app-dropdown-option>
            </div>
            <div class="col-md-2">
              <mat-form-field>
                <input matInput name="PackageContent" [(ngModel)]="Copy.BatchAmount"
                       placeholder="Package Content">
                <mat-hint>Amount of articles this packaging contains</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-3">
              <app-dropdown-option [(ngModel)]="Copy.PackageType"
                                   discriminator="PackageType" model="Article"
                                   name="PackageType" placeholder="Package type"></app-dropdown-option>
            </div>
            <div class="col-3">
              <app-dropdown-option [(ngModel)]="Copy.Packaging"
                                   [required]="Copy?.Category1?.Id != '048dd111-025c-4788-93a1-e41ae3d34471'"
                                   discriminator="Packaging" model="Article"
                                   name="Packaging" placeholder="Packaging"></app-dropdown-option>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <mat-form-field>
                <input matInput name="Step" [(ngModel)]="Copy.Step" type="number"
                       placeholder="Step">
                <mat-hint>When step is 2 you can order 2, 4, 6, .. pieces.</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <input [(ngModel)]="Copy.SalesPrice" matInput name="SalesPrice"
                       placeholder="Default Price">
                <mat-hint>When not in price list, default to this price</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <input matInput name="MinQTY" [(ngModel)]="Copy.MinQTY"
                       placeholder="Minimum order quanitity">
                <mat-hint>Minimum order quantity >= step</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <input [(ngModel)]="Copy.MaxQTY" matInput name="MaxQTY"
                       placeholder="Maximum order quanitity">
                <mat-hint>Maximum amount a reseller account can order</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-3">
              <mat-form-field>
                <input matInput name="Start" placeholder="Start date"
                       [(ngModel)]="Copy.Start" [matDatepicker]="picker1">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 [startAt]="Copy.Start "></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field>
                <input matInput name="End" placeholder="End date"
                       [(ngModel)]="Copy.End " [matDatepicker]="picker2">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2 [startAt]="Copy.End "></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field>
                <input matInput name="InStockDate" placeholder="In Stock Date"
                       [(ngModel)]="Copy.InStockDate " [matDatepicker]="picker3">
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3 [startAt]="Copy.InStockDate"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field>
                <input [(ngModel)]="Copy.Order" matInput name="Order" placeholder="The order, ascending" type="number">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-group-selector name="Groups" [multiple]="true" [(ngModel)]="Copy.Groups"></app-group-selector>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-dropdown-option model="ArticleCategory" placeholder="Categories" discriminator="Category"
                                   [(ngModel)]="Copy.Categories" name="ArticleCategories"
                                   multiple></app-dropdown-option>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-dropdown-option [(ngModel)]="Copy.BlockedSupplyPlants" [getOnlyId]="true" discriminator="SupplyPlant"
                                   mathint="Blocked articles are not visible in the reseller neither aorta."
                                   model="Address" multiple name="BlockedSupplyPlants"
                                   placeholder="Blocked supply plants"></app-dropdown-option>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Properties">
          <div class="row">
            <div class="col-md-4">
              <mat-form-field>
                <input matInput name="Length" [(ngModel)]="Copy.Length"
                       placeholder="Length (cm)" (ngModelChange)="calcVolume()">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <input matInput name="Width" [(ngModel)]="Copy.Width" placeholder="Width (cm)"
                       (ngModelChange)="calcVolume()">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <input matInput name="Height" [(ngModel)]="Copy.Height"
                       placeholder="Height (cm)" (ngModelChange)="calcVolume()">
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 col-lg-4">
              <mat-form-field>
                <input matInput name="Stock" [(ngModel)]="Copy.Stock"
                       placeholder="Stock">
              </mat-form-field>
            </div>
            <div class="col-sm-6 col-lg-4">
              <mat-form-field>
                <input [(ngModel)]="Copy.Weight" matInput name="Weight" placeholder="Weight (kg)">
                <mat-icon matSuffix matTooltip="This field will be synchronised with Exact">cloud_upload</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-sm-6 col-lg-4">
              <mat-form-field>
                <input matInput name="Volume" [(ngModel)]="Copy.Volume"
                       placeholder="Volume (dm3)">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <mat-checkbox [(ngModel)]="Copy.IsNew" name="IsNew">
                New
              </mat-checkbox>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="Copy.Id" label="Children ({{Copy.Children?.length}})">
          <table class="mat-table mat-elevation-z8" style="min-width: 400px">
            <thead>
            <tr class="mat-row">
              <th class="mat-header-cell" style="flex: none; width: 140px;">Code</th>
              <th class="mat-header-cell" style="flex: none; width: 100px;">Amount</th>
              <th class="mat-header-cell">Description</th>
              <th class="mat-header-cell">Blocked</th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell" style="flex: none; width: 100px;"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let article of Copy.Children; let i = index" class="mat-row">
              <td class="mat-cell" style="flex: none; width: 140px;">
                      <span [class.highlight]="article.Id === this.Copy?.Id"
                            [matTooltip]="article.Id === this.Copy?.Id ? 'This is the parent!' : undefined">
                        {{article.Code}}
                      </span>
              </td>
              <td class="mat-cell" style="flex: none; width: 100px;">
                <strong>{{article.OptionWeight}}{{article.Unit?.Value}}
                  x {{article.BatchAmount}} {{article.Packaging?.Value}}</strong>
              </td>
              <td class="mat-cell">{{article.Description}}</td>
              <td class="mat-cell">
                <mat-icon>{{article.IsBlocked ? 'check' : 'clear'}}</mat-icon>
              </td>
              <td class="mat-cell">
                <mat-icon *ngIf="Copy.IsBlocked" matTooltipPosition="above" matTooltip="Parent is blocked!">warning</mat-icon>
              </td>
              <td class="mat-cell" style="flex: none; width: 100px;">
                <button (click)="swapPosition(article, -1)" [disabled]="i === 0" mat-icon-button type="button">
                  <mat-icon>arrow_upward</mat-icon>
                </button>
                <button (click)="swapPosition(article, 1)" [disabled]="i === this.Copy.Children.length - 1"
                        mat-icon-button type="button">
                  <mat-icon>arrow_downward</mat-icon>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </mat-tab>
        <mat-tab label="Stock" *ngIf="Copy.Id">
          <table class="table table-sm table-hover align-middle m-0" style="min-width: 400px">
            <thead>
            <tr>
              <th>Supply Plant</th>
              <th style="text-align: center">Back in stock date</th>
              <th>Current stock </th>
              <th style="width: 85px; text-align: right;">
                <button (click)="lEditor.edit({Article: {Id: Copy.Id}})" mat-icon-button type="button">
                  <mat-icon>add</mat-icon>
                </button>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let info of Copy.Locations">
              <td>{{info.SupplyPlant?.Value}}</td>
              <td style="text-align: center">{{info.InStockDate | date: 'shortDate'}}</td>
              <td>{{info.CurrentStock}}</td>
              <td style="width: 85px; text-align: right;">
                <button (click)="lEditor.edit(info)" mat-icon-button type="button">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" mat-icon-button appConfirmDialog
                        (confirm)="lEditor.remove(info)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </mat-tab>
      </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="fill-remaining-space"></div>
      <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
      <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading || isLoadingEO"></app-button>
    </mat-dialog-actions>
  </form>
</ng-template>

<app-location-editor #lEditor [(List)]="Copy.Locations"></app-location-editor>
